var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.696 55.4936C104.696 54.1869 106.047 53.1276 107.714 53.1276C109.381 53.1276 110.732 54.1869 110.732 55.4936V64.0115C110.732 65.3183 109.381 66.3776 107.714 66.3776C106.047 66.3776 104.696 65.3183 104.696 64.0115V55.4936Z",
    fill: "url(#paint0_linear_288_2374)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03658 55.4936C6.03658 54.1869 4.68525 53.1276 3.01829 53.1276C1.35133 53.1276 0 54.1869 0 55.4936V64.0115C0 65.3183 1.35133 66.3776 3.01829 66.3776C4.68525 66.3776 6.03658 65.3183 6.03658 64.0115V55.4936Z",
    fill: "url(#paint1_linear_288_2374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1219 49.8151C20.1219 48.5083 18.7706 47.449 17.1036 47.449C15.4367 47.449 14.0854 48.5083 14.0854 49.8151V69.6901C14.0854 70.9969 15.4367 72.0562 17.1036 72.0562C18.7706 72.0562 20.1219 70.9969 20.1219 69.6901V49.8151Z",
    fill: "url(#paint2_linear_288_2374)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6105 49.8151C90.6105 48.5083 91.9618 47.449 93.6288 47.449C95.2957 47.449 96.6471 48.5083 96.6471 49.8151V69.6901C96.6471 70.9969 95.2957 72.0562 93.6288 72.0562C91.9618 72.0562 90.6105 70.9969 90.6105 69.6901V49.8151Z",
    fill: "url(#paint3_linear_288_2374)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0065 40.4636H66.2353C71.7323 40.4636 76.1885 44.9198 76.1885 50.4168V58.0476H82.824V50.4168C82.824 41.2551 75.397 33.8281 66.2353 33.8281H44.0065C34.8448 33.8281 27.4178 41.2551 27.4178 50.4168V58.0476H34.0532V50.4168C34.0532 44.9198 38.5095 40.4636 44.0065 40.4636Z",
    fill: "#8A9AA8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0532 64.6831H27.4178V72.6457C27.4178 81.8073 34.8448 89.2343 44.0065 89.2343H66.2353C75.397 89.2343 82.824 81.8073 82.824 72.6457V64.6831H76.1885V72.6457C76.1885 78.1427 71.7323 82.5989 66.2353 82.5989H44.0065C38.5095 82.5989 34.0532 78.1427 34.0532 72.6457V64.6831Z",
    fill: "#8A9AA8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.684 57.7125C41.684 56.6149 42.5738 55.7251 43.6714 55.7251H47.991C49.0886 55.7251 49.9784 56.6149 49.9784 57.7125V65.3498C49.9784 66.4474 49.0886 67.3372 47.991 67.3372H43.6714C42.5738 67.3372 41.684 66.4474 41.684 65.3498V57.7125Z",
    fill: "#8A9AA8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9316 57.7125C59.9316 56.6149 60.8214 55.7251 61.919 55.7251H66.2385C67.3362 55.7251 68.2259 56.6149 68.2259 57.7125V65.3498C68.2259 66.4474 67.3362 67.3372 66.2385 67.3372H61.919C60.8214 67.3372 59.9316 66.4474 59.9316 65.3498V57.7125Z",
    fill: "#8A9AA8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6243 27.1707H57.5415V38.1313H51.6243V27.1707Z",
    fill: "#8A9AA8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2354 29.4566C59.557 29.4566 63.871 25.1427 63.871 19.8211C63.871 14.4995 59.557 10.1855 54.2354 10.1855C48.9139 10.1855 44.5999 14.4995 44.5999 19.8211C44.5999 25.1427 48.9139 29.4566 54.2354 29.4566ZM52.5692 15.9089L52.5692 18.1548H50.3233C49.403 18.1548 48.657 18.9008 48.657 19.8211C48.657 20.7414 49.403 21.4874 50.3233 21.4874L52.5692 21.4874V23.7333C52.5692 24.6535 53.3152 25.3996 54.2355 25.3996C55.1557 25.3996 55.9018 24.6535 55.9018 23.7333L55.9018 21.4874H58.1476C59.0679 21.4874 59.8139 20.7414 59.8139 19.8211C59.8139 18.9008 59.0679 18.1548 58.1476 18.1548L55.9018 18.1548V15.9089C55.9018 14.9887 55.1557 14.2426 54.2355 14.2426C53.3152 14.2426 52.5692 14.9887 52.5692 15.9089Z",
    fill: "#8A9AA8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1933 87.1509C48.344 87.1509 47.6554 87.8394 47.6554 88.6888V98.1228C47.6554 99.3593 49.0401 100.09 50.0525 99.3806C53.8891 96.6906 58.0478 93.542 61.8799 89.627C62.8018 88.6851 62.1129 87.1509 60.795 87.1509H49.1933Z",
    fill: "#8A9AA8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_288_2374",
    x1: 0.00000202041,
    y1: 43.2745,
    x2: 206.591,
    y2: 64.6831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AD0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9429FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_288_2374",
    x1: 0.00000202041,
    y1: 43.2745,
    x2: 206.591,
    y2: 64.6831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AD0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9429FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_288_2374",
    x1: 0.00000202041,
    y1: 43.2745,
    x2: 206.591,
    y2: 64.6831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AD0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9429FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_288_2374",
    x1: 0.00000202041,
    y1: 43.2745,
    x2: 206.591,
    y2: 64.6831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AD0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9429FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c55b9d98f296682830b164db07a03df1.svg";
export { ForwardRef as ReactComponent };